export const fontSizeBase = 16;
export const colorNeutral15 = "#D8D8D8";
export const colorNeutral20 = "#D8D8D8";
export const colorNeutral30 = "#B2B2B2";
export const colorNeutral40 = "#90969A";
export const colorNeutral60 = "#5E666B";
export const colorNeutral80 = "#2F3A40";
export const colorNeutralDefault = "#111416";
export const colorNeutralWhite = "#FFFFFF";
export const colorNeutral02 = "#FBFBFB";
export const colorNeutral03 = "#FBFBFB";
export const colorNeutral05 = "#F2F2F2";
export const colorBrand1Active = "#003242";
export const colorBrand1Base = "#004455";
export const colorBrand1Hover = "#004455";
export const colorBrand1Tint = "#F2FAFC";
export const colorBrand1Highlight = "#D7E9EB";
export const colorBrand2Active = "#DE843D";
export const colorBrand2Base = "#E9A165";
export const colorBrand2Hover = "#FFFFFF"; // NOTE: Should not be used, will be deleted, set to white until removal
export const colorBrand2Tint = "#FFFFFF"; // NOTE: Should not be used, will be deleted, set to white until removal
export const colorActionActive = "#004562";
export const colorActionBase = "#006586";
export const colorActionHover = "#5EB5D5";
export const colorActionTint = "#FBFBFB";
export const colorMessageSuccessBase = "#088463";
export const colorMessageSuccessHover = "#006A4A";
export const colorMessageSuccessTint = "#E3F0EC";
export const colorMessageWarningBase = "#FCBF38";
export const colorMessageWarningHover = "#FCBF38";
export const colorMessageWarningTint = "#FFF8E8";
export const colorMessageErrorBase = "#BE4025";
export const colorMessageErrorHover = "#FCEDED";
export const colorMessageErrorTint = "#FDF5F5";
export const colorDecPurple10 = "#E7E9F4";
export const colorDecPurple15 = "#E7E9F4";
export const colorDecPurple100 = "#9FA7D4";
export const colorDecPurple150 = "#292B60";
export const colorDecTurquoise10 = "#D7E9EB";
export const colorDecTurquoise20 = "#BAD6DE";
export const colorDecTurquoise30 = "#98C4CB";
export const colorDecTurquoise40 = "#6BA8AD";
export const colorDecTurquoise60 = "#007A84";
export const colorDecTurquoise80 = "#007A84";
export const colorDecTurquoise100 = "#005D66";
export const colorDecTurquoise03 = "#F2FAFC";
export const colorDecTurquoise05 = "#F2FAFC";
export const colorDecIndigo05 = "#F3F4F9";
export const colorDecIndigo10 = "#E7E9F4";
export const colorDecIndigo15 = "#E7E9F4";
export const colorDecIndigo30 = "#C5C9E1";
export const colorDecIndigo50 = "#6069A8";
export const colorDecIndigo60 = "#4C5693";
export const colorDecIndigo80 = "#38427F";
export const colorDecIndigo100 = "#818ECE";
export const colorDecIndigo200 = "#4C5693";
export const colorDecBlue10 = "#D6E4EF";
export const colorDecBlue15 = "#E2EDF3";
export const colorDecBlue100 = "#326EB1";
export const colorDecCyan10 = "#D0EEF3";
export const colorDecCyan100 = "#23ACCB";
export const colorDecKelly03 = "#E3F0EC";
export const colorDecKelly10 = "#D8ECE7";
export const colorDecKelly100 = "#7BB190";
export const colorDecGreen10 = "#E3F0EC";
export const colorDecGreen15 = "#D8ECE7";
export const colorDecGreen30 = "#7BB190";
export const colorDecGreen50 = "#088463";
export const colorDecGreen60 = "#006A4A";
export const colorDecGreen100 = "#479672";
export const colorDecYellow02 = "#FFF8E8";
export const colorDecYellow03 = "#FFF8E8";
export const colorDecYellow10 = "#FEF0CF";
export const colorDecYellow15 = "#FEF0CF";
export const colorDecYellow40 = "#FDD77F";
export const colorDecYellow60 = "#FCBF38";
export const colorDecYellow100 = "#FBCA5E";
export const colorDecOrange10 = "#F9D9BF";
export const colorDecOrange100 = "#D56D1F";
export const colorDecRed10 = "#F5E0DC";
export const colorDecRed15 = "#F5E0DC";
export const colorDecRed60 = "#BE4025";
export const colorDecRed70 = "#982C0E";
export const colorDecRed100 = "#DA6D50";
export const colorDecBrown100 = "#8E4F17";
export const colorDecBlack30 = "#111416";
export const colorDecSandElevationMinus1 = "#E7DBD0";
export const colorDecSandElevation0 = "#F3EEE9";
export const colorDecSandElevation1 = "#FDFBF7";
export const colorDecSandElevation2 = "#FFFEFD";
export const colorAccessibilityFocusDefault = "#185998";
export const colorNeutral700 = "#5E666B";
export const colorNeutral800 = "#2F3A40";
export const colorNeutral900 = "#192124";
export const colorNeutral950 = "#111416";
export const colorNeutralBlack = "#000000";
export const colorSand100 = "#FDFBF7";
export const colorSand200 = "#F3EEE9";
export const colorSand300 = "#E7DBD0";
export const colorSand350 = "#DACBBD";
export const colorSand600 = "#685F57";
export const colorSand800 = "#332D26";
export const colorTerra50 = "#F8F1EB";
export const colorTerra100 = "#F5EAE1";
export const colorTerra300 = "#E9D0BD";
export const colorTerra700 = "#8E4F17";
export const colorTerra800 = "#5F310F";
export const colorTeal100 = "#D7E9EB";
export const colorTeal200 = "#BAD6DE";
export const colorTeal800 = "#003242";
export const colorBlue100 = "#D6E4EF";
export const colorBlue200 = "#A6C2DB";
export const colorBlue300 = "#79A2C8";
export const colorBlue600 = "#185998";
export const colorIndigo100 = "#E7E9F4";
export const colorIndigo600 = "#4C5693";
export const colorIndigo700 = "#38427F";
export const colorGreen200 = "#A6CFBE";
export const colorGreen500 = "#088463";
export const colorGreen600 = "#006A4A";
export const colorGreen700 = "#005134";
export const colorYellow700 = "#AC7600";
export const colorYellow800 = "#825601";
export const colorWarningDark = "#AD6E00";
export const colorRed700 = "#7B1500";
export const colorTextPrimary = "#192124";
export const colorTextPrimaryDefault = "#4C5693";
export const colorTextSecondary = "#5F6777";
export const colorTextNeutralSecondary = "#5E666B";
export const colorTextNeutralDisabled = "#B2B2B2";
export const colorTextWarningDefault = "#825601";
export const colorTextNegativeDefault = "#7B1500";
export const colorMainAction = "#0D6A97";
export const colorInteractivePrimary = "#326BDC";
export const elevation01 = "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)";
export const elevation04 = "0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)";
export const elevation08 = "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.2)";
export const dropShadow01 = "0px 1px 2px 0px rgba(0, 0, 0, 0.05)";
export const dropShadow02 = "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10)";
export const dropShadow03 = "0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)";
export const dropShadow04 = "0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)";
export const dropShadow05 = "0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10)";
export const dropShadow06 = "0px 25px 50px -12px rgba(0, 0, 0, 0.25)";
export const dropShadow07 = "0px 25px 50px 0px rgba(0, 0, 0, 0.08)";
export const innerShadow01 = "0 2px 4px 0 rgba(0, 0, 0, 0.05) inset";
export const spacing00 = "0px";
export const spacing01 = "0.25rem";
export const spacing02 = "0.5rem";
export const spacing03 = "1rem";
export const spacing04 = "1.5rem";
export const spacing05 = "2rem";
export const spacing06 = "2.5rem";
export const spacing07 = "3rem";
export const spacing08 = "3.5rem";
export const fontFamilyInclusiveSans = "Inclusive Sans";
export const fontFamilyLora = "lora";
export const fontFamilyFallback = "Arial";
export const fontLetterSpacing00 = "normal";
export const fontLetterSpacing01 = "0.005em";
export const fontLetterSpacing02 = "0.01em";
export const fontLetterSpacing03 = "0.0125em";
export const fontLetterSpacing04 = "0.0325em";
export const fontLineHeight10 = "3.5rem";
export const fontLineHeight01 = "0.875rem";
export const fontLineHeight02 = "1rem";
export const fontLineHeight03 = "1.125rem";
export const fontLineHeight04 = "1.25rem";
export const fontLineHeight05 = "1.375rem";
export const fontLineHeight06 = "1.5rem";
export const fontLineHeight07 = "1.75rem";
export const fontLineHeight08 = "2rem";
export const fontLineHeight09 = "2.25rem";
export const fontSize01 = "0.625rem";
export const fontSize02 = "0.75rem";
export const fontSize03 = "0.875rem";
export const fontSize04 = "1rem";
export const fontSize05 = "1.125rem";
export const fontSize06 = "1.25rem";
export const fontSize07 = "1.5rem";
export const fontSize08 = "1.75rem";
export const fontSize09 = "2.25rem";
export const fontSize10 = "3rem";
export const fontWeightLight = "300";
export const fontWeightNormal = "400";
export const fontWeightMedium = "500";
export const fontWeightSemibold = "600";
export const fontWeightBold = "700";
export const breakpointXs = "599px";
export const breakpointSm = "959px";
export const breakpointTablet = "1149px";
export const breakpointMd = "1439px";
export const breakpointLg = "1919px";
export const mediaQueryExpressionAll = "all";
export const mediaQueryExpressionPrint = "print";
export const mediaQueryExpressionScreen = "screen";
export const mediaQueryExpressionSpeech = "speech";
export const mediaQueryExpressionLandscape = "'(orientation: landscape)'";
export const mediaQueryExpressionPortrait = "'(orientation: portrait)'";
export const mediaQueryUnitIntervalsPx = "1";
export const mediaQueryUnitIntervalsEm = "0.01";
export const mediaQueryUnitIntervalsRem = "0.1";
export const borderRadius00 = "0";
export const borderRadius01 = "0.125rem";
export const borderRadius02 = "0.25rem";
export const borderRadius03 = "0.5rem";
export const borderRadius04 = "1rem";
export const borderRadius045 = "1.25rem";
export const borderRadius05 = "1.5rem";
export const borderRadius06 = "2rem";
export const borderRadiusFull = "50%";
export const colorNeutral50 = "#FFFFFF";
export const colorNeutral100 = "#FBFBFB";
export const colorNeutral200 = "#F2F2F2";
export const colorNeutral300 = "#E4E3E0";
export const colorNeutral400 = "#D8D8D8";
export const colorNeutral500 = "#B2B2B2";
export const colorNeutral600 = "#90969A";
export const colorSand50 = "#FFFEFD";
export const colorSand400 = "#B9AEA4";
export const colorSand500 = "#90867D";
export const colorSand700 = "#484039";
export const colorSand900 = "#211D18";
export const colorSand950 = "#181613";
export const colorRed50 = "#FDF5F5";
export const colorRed100 = "#FCEDED";
export const colorRed200 = "#F5E0DC";
export const colorRed300 = "#F4A996";
export const colorRed400 = "#DA6D50";
export const colorRed500 = "#BE4025";
export const colorRed600 = "#982C0E";
export const colorRed800 = "#5B0500";
export const colorRed900 = "#3A0100";
export const colorRed950 = "#290200";
export const colorTerra200 = "#EEDCCD";
export const colorTerra400 = "#DAA87E";
export const colorTerra500 = "#C18144";
export const colorTerra600 = "#AA661C";
export const colorTerra900 = "#3D210B";
export const colorTerra950 = "#281B11";
export const colorYellow50 = "#FFF8E8";
export const colorYellow100 = "#FEF0CF";
export const colorYellow200 = "#FDDF9B";
export const colorYellow300 = "#FDD77F";
export const colorYellow400 = "#FBCA5E";
export const colorYellow500 = "#FCBF38";
export const colorYellow600 = "#D69905";
export const colorYellow900 = "#412D15";
export const colorYellow950 = "#221A11";
export const colorGreen50 = "#E3F0EC";
export const colorGreen100 = "#D8ECE7";
export const colorGreen300 = "#7BB190";
export const colorGreen400 = "#479672";
export const colorGreen800 = "#003920";
export const colorGreen900 = "#012210";
export const colorGreen950 = "#03160A";
export const colorTeal50 = "#F2FAFC";
export const colorTeal300 = "#98C4CB";
export const colorTeal400 = "#6BA8AD";
export const colorTeal500 = "#007A84";
export const colorTeal600 = "#005D66";
export const colorTeal700 = "#004455";
export const colorTeal900 = "#001B25";
export const colorTeal950 = "#001219";
export const colorCyan50 = "#EDFDFE";
export const colorCyan100 = "#D0EEF3";
export const colorCyan200 = "#ABDAE9";
export const colorCyan300 = "#8AC5E3";
export const colorCyan400 = "#5EB5D5";
export const colorCyan500 = "#23ACCB";
export const colorCyan600 = "#0088AA";
export const colorCyan700 = "#006586";
export const colorCyan800 = "#004562";
export const colorCyan900 = "#002740";
export const colorCyan950 = "#001931";
export const colorBlue50 = "#E2EDF3";
export const colorBlue400 = "#5083B7";
export const colorBlue500 = "#326EB1";
export const colorBlue700 = "#00447E";
export const colorBlue800 = "#00325D";
export const colorBlue900 = "#001F40";
export const colorBlue950 = "#001734";
export const colorIndigo50 = "#F3F4F9";
export const colorIndigo200 = "#C5C9E1";
export const colorIndigo300 = "#9FA7D4";
export const colorIndigo400 = "#818ECE";
export const colorIndigo500 = "#6069A8";
export const colorIndigo800 = "#292B60";
export const colorIndigo900 = "#1A173B";
export const colorIndigo950 = "#120F29";
export const colorOrange50 = "#FDF0E6";
export const colorOrange100 = "#F9D9BF";
export const colorOrange200 = "#F2BE91";
export const colorOrange300 = "#E9A165";
export const colorOrange400 = "#DE843D";
export const colorOrange500 = "#D56D1F";
export const colorOrange600 = "#B95712";
export const colorOrange700 = "#934000";
export const colorOrange800 = "#6D2C00";
export const colorOrange900 = "#421900";
export const colorOrange950 = "#261003";
export const colorDecIndigo40 = "#C5C9E1";
export const colorNeutralBlackOpacity04 = "#0000000A";